<template>
  <coozzy-card :title="$t('message.settings.notifications')">
    <div
      v-if="loading"
      style="height: 30px">
      <coozzy-spinner />
    </div>
    <div v-else>
      <div class="col-12 mt-3">
        <b-card-sub-title class="mb-3">
          {{ $t('message.settings.notification.notifiedMethod.label') }}
        </b-card-sub-title>
        <coozzy-form-select
          v-model="notifiedMethod"
          name="notifiedMethod"
          class="w-25">
          <option value="">
            -
          </option>
          <option value="NOTIFICATION_CHANNEL_EMAIL">
            {{ $t('message.settings.notification.notifiedMethod.email') }}
          </option>
          <option value="NOTIFICATION_CHANNEL_PUSH">
            {{ $t('message.settings.notification.notifiedMethod.module') }}
          </option>
          <option value="emailAndModule">
            {{ $t('message.settings.notification.notifiedMethod.emailAndModule') }}
          </option>
        </coozzy-form-select>
      </div>
      <div
        class="col-12 mt-3">
        <b-card-sub-title class="mb-3">
          {{ $t('message.settings.notification.notificationsReceived.label') }}
        </b-card-sub-title>
        <coozzy-form-checkbox
          v-model="ticketNotifications.created"
          :initial="ticketNotifications.created">
          {{ $t('message.settings.notification.notificationsReceived.ticketCreated') }}
        </coozzy-form-checkbox>
        <coozzy-form-checkbox
          v-model="ticketNotifications.deleted"
          :initial="ticketNotifications.deleted">
          {{ $t('message.settings.notification.notificationsReceived.ticketDeleted') }}
        </coozzy-form-checkbox>
        <coozzy-form-checkbox
          v-model="ticketNotifications.assigned"
          :initial="ticketNotifications.assigned">
          {{ $t('message.settings.notification.notificationsReceived.ticketResponsible') }}
        </coozzy-form-checkbox>
        <coozzy-form-checkbox
          v-model="ticketNotifications.statusChanged"
          :initial="ticketNotifications.statusChanged">
          {{ $t('message.settings.notification.notificationsReceived.statusChange') }}
        </coozzy-form-checkbox>
        <coozzy-form-checkbox
          v-model="ticketNotifications.comments"
          :initial="ticketNotifications.comments">
          {{ $t('message.settings.notification.notificationsReceived.newComments') }}
        </coozzy-form-checkbox>
        <coozzy-form-checkbox
          v-model="ticketNotifications.updated"
          :initial="ticketNotifications.updated">
          {{ $t('message.settings.notification.notificationsReceived.newMention') }}
        </coozzy-form-checkbox>
        <coozzy-form-checkbox
          v-model="ticketNotifications.overdue"
          :initial="ticketNotifications.overdue">
          {{ $t('message.settings.notification.notificationsReceived.ticketOverdue') }}
        </coozzy-form-checkbox>
        <coozzy-form-checkbox
          v-model="ticketNotifications.invoiceAdded"
          :initial="ticketNotifications.invoiceAdded">
          {{ $t('message.settings.notification.notificationsReceived.invoiceAdded') }}
        </coozzy-form-checkbox>
        <coozzy-form-checkbox
          v-if="isDeepOEnabled"
          v-model="ticketNotifications.externalInvoiceAdded"
          :initial="ticketNotifications.externalInvoiceAdded">
          {{ $t('message.settings.notification.notificationsReceived.externalInvoiceAdded') }}
        </coozzy-form-checkbox>
        <coozzy-form-checkbox
          v-if="isGoCautionEnabled"
          v-model="otherNotifications.depositConfirmationReceived"
          :initial="otherNotifications.depositConfirmationReceived">
          {{ $t('message.settings.notification.notificationsReceived.gocautionDepositConfirmation') }}
        </coozzy-form-checkbox>
        <coozzy-form-checkbox
          v-if="isFirstCautionEnabled"
          v-model="otherNotifications.firstcautionDepositConfirmationReceived"
          :initial="otherNotifications.firstcautionDepositConfirmationReceived">
          {{ $t('message.settings.notification.notificationsReceived.firstcautionDepositConfirmation') }}
        </coozzy-form-checkbox>
      </div>
      <div
        class="col-12 mt-3">
        <b-card-sub-title class="mb-3">
          {{ $t('message.settings.notification.notificationsReceived.marketbaseTitle') }}
        </b-card-sub-title>
        <coozzy-form-checkbox
          v-model="marketbaseNotifications.newRequest"
          :initial="marketbaseNotifications.newRequest">
          {{ $t('message.settings.notification.notificationsReceived.marketbaseNewRequest') }}
        </coozzy-form-checkbox>
        <coozzy-form-checkbox
          v-model="marketbaseNotifications.newRegistration"
          :initial="marketbaseNotifications.newRegistration">
          {{ $t('message.settings.notification.notificationsReceived.marketbaseNewRegistration') }}
        </coozzy-form-checkbox>
        <coozzy-form-checkbox
          v-model="marketbaseNotifications.newResponse"
          :initial="marketbaseNotifications.newResponse">
          {{ $t('message.settings.notification.notificationsReceived.marketbaseNewResponse') }}
        </coozzy-form-checkbox>
        <coozzy-form-checkbox
          v-model="marketbaseNotifications.viewingAppointmentsScheduled"
          :initial="marketbaseNotifications.viewingAppointmentsScheduled">
          {{ $t('message.settings.notification.notificationsReceived.marketbaseViewingAppointmentsScheduled') }}
        </coozzy-form-checkbox>
        <coozzy-form-checkbox
          v-model="marketbaseNotifications.referencesReceived"
          :initial="marketbaseNotifications.referencesReceived">
          {{ $t('message.settings.notification.notificationsReceived.marketbaseReferencesReceived') }}
        </coozzy-form-checkbox>
      </div>
      <div class="col">
        <coozzy-button
          class="float-right mt-3"
          design="green"
          @click="saveSettings">
          {{ $t('message.generic.form.save') }}
        </coozzy-button>
      </div>
    </div>
  </coozzy-card>
</template>
<script>
import CoozzyCard from '../../framework/components/card/CoozzyCard'
import UserApi from '../../misc/apis/UserApi'
import Vue from 'vue'
import store from '../../store/store'
import CoozzyFormCheckbox from '@/framework/components/form/checkbox/CoozzyFormCheckbox'
import CoozzyFormSelect from '@/framework/components/form/select/CoozzyFormSelect'
import CoozzySpinner from '@/framework/components/misc/CoozzySpinner'
import CoozzyButton from '@/framework/components/button/CoozzyButton'
import DeepOApi from '@/misc/apis/DeepOApi'
import GocautionApi from '@/misc/apis/GocautionApi'
import FirstcautionApi from '@/misc/apis/FirstcautionApi'
import { user } from '@/mixins/user'

export default {
  name: 'NotificationsSettings',
  components: {
    CoozzyButton,
    CoozzySpinner,
    CoozzyFormSelect,
    CoozzyFormCheckbox,
    CoozzyCard
  },
  mixins: [user],
  data() {
    const defaultTicketNotifications = {
      assigned: false,
      created: false,
      comments: false,
      statusChanged: false,
      updated: false,
      deleted: false,
      overdue: false,
      invoiceAdded: false,
      externalInvoiceAdded: false
    }
    const defaultOtherNotifications = {
      depositConfirmationReceived: true,
      firstcautionDepositConfirmationReceived: true
    }
    const defaultMarketbaseNotifications = {
      newRequest: false,
      newRegistration: false,
      newResponse: false,
      viewingAppointmentsScheduled: false,
      referencesReceived: false
    }
    return {
      notifiedMethod: '',
      loading: false,
      ticketNotifications: defaultTicketNotifications,
      otherNotifications: defaultOtherNotifications,
      marketbaseNotifications: defaultMarketbaseNotifications,
      isDeepOEnabled: false,
      isGoCautionEnabled: false,
      isFirstCautionEnabled: false
    }
  },
  mounted: function () {
    this.loadProviderStatus()
    this.loading = true
    UserApi.getNotificationSettings(store.getters['user/getUserId'])
      .then(response => {
        if (response.settings.channels.includes('NOTIFICATION_CHANNEL_EMAIL') && response.settings.channels.includes('NOTIFICATION_CHANNEL_PUSH')) {
          this.notifiedMethod = 'emailAndModule'
        } else {
          this.notifiedMethod = response.settings.channels.length > 0 ? response.settings.channels[0] : ''
        }
        this.ticketNotifications = {
          ...this.ticketNotifications,
          ...(response.settings.ticketNotifications || {})
        }
        this.otherNotifications = {
          ...this.otherNotifications,
          ...(response.settings.otherNotifications || {})
        }
        this.marketbaseNotifications = {
          ...this.marketbaseNotifications,
          ...(response.settings.marketbaseNotifications || {})
        }
        // Backward compatibility for users who may still have the old field in ticketNotifications.
        if (!response.settings.otherNotifications && response.settings.ticketNotifications?.gocautionDepositConfirmation !== undefined) {
          this.otherNotifications.depositConfirmationReceived = response.settings.ticketNotifications.gocautionDepositConfirmation
        }
        this.loading = false
      })
      .catch(e => {
        console.log(e)
        this.loading = false
        Vue.toasted.show(this.$t('message.loadingErrors.accountSettings'), { type: 'error' })
      })
  },
  methods: {
    loadProviderStatus() {
      DeepOApi.isDeepOEnabled(this.accountId)
        .then(response => {
          this.isDeepOEnabled = !!response?.enabled
        })
        .catch(e => {
          console.log(e)
        })
      GocautionApi.hasEnabled(this.accountId)
        .then(response => {
          this.isGoCautionEnabled = !!response?.enabled
        })
        .catch(e => {
          console.log(e)
        })
      FirstcautionApi.hasEnabled(this.accountId)
        .then(response => {
          this.isFirstCautionEnabled = !!response?.enabled
        })
        .catch(e => {
          console.log(e)
        })
    },
    saveSettings() {
      this.loading = true
      const notificationMethod = []
      if (this.notifiedMethod === 'emailAndModule') {
        notificationMethod.push('NOTIFICATION_CHANNEL_EMAIL')
        notificationMethod.push('NOTIFICATION_CHANNEL_PUSH')
      } else {
        notificationMethod.push(this.notifiedMethod)
      }
      UserApi.postNotificationSettings(notificationMethod, this.ticketNotifications, this.otherNotifications, this.marketbaseNotifications, store.getters['user/getUserId'])
        .then(() => {
          this.loading = false
          Vue.toasted.show(this.$t('message.successMessages.notificationUpdated'), { type: 'success' })
        })
        .catch(e => {
          console.log(e)
          this.loading = false
          Vue.toasted.show(this.$t('message.savingErrors.accountSettings'), { type: 'error' })
        })
    }
  }
}
</script>
